import { useEffect, useState } from "react";
import logo from "../assets/brand/logo.png";
import { useSearchParams } from "react-router-dom";
import { handleVerifyEmail } from "../services/emailActions";
import PageNotFound from "./page_not_found";
import { Loader } from "../hooks/useLoading";

const VerifyEmail = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchParams] = useSearchParams();

  const actionCode = searchParams.get("oobCode");

  useEffect(() => {
    async function initiate() {
      if (!actionCode) {
        setError("Please check the URL");
        return;
      }
      const resp = await handleVerifyEmail({ actionCode });
      setLoading(false);
      if (resp.error) {
        setError(resp.error);
      }
    }
    initiate();
  }, [actionCode]);

  if (!actionCode) {
    return <PageNotFound />;
  }

  return (
    <>
      <header
        style={{
          width: "100%",
          // background: "rgb(255,208,115)",
          background:
            "linear-gradient(270deg, rgba(255,208,115,1) 25%, rgba(213,162,62,1) 50%, rgba(179,130,36,1) 75%)",
          height: "50px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <img src={logo} alt="logo" height={40} />
      </header>
      <main className="w-50 m-auto mt-5">
        {loading ? (
          <div>
            <Loader />
          </div>
        ) : error ? (
          <div className="text-center"> {error} </div>
        ) : (
          <div class="card">
            <div className="card-header text-center">Congratulations</div>
            <div class="card-body text-center">
              Your email has been verified successfully.
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default VerifyEmail;
